// PASTE #229/#231 Wave 3: language-agnostic wedding-cluster data. All
// localized copy (FAQ, HowTo, headings, labels, table row names) now
// lives in lib/i18n/wedding-strings.ts. This module keeps only the parts
// that are identical across locales: the stem-count table's numeric
// values and the calculator's design order.

import type { DesignKey } from "@/lib/wedding/calculator";

// Guide "stem counts by design" table - numeric focal-stem values (same
// in every locale). Row labels come from wedding-strings tableRowLabels
// keyed by `key`. Order follows the guide source table. Display strings
// preserve the guide's "40+" / "400+" notation.
export type StemRow = {
  key: DesignKey;
  small: string;
  medium: string;
  large: string;
};
export const STEM_TABLE_VALUES: StemRow[] = [
  { key: "bridalBouquet", small: "25", medium: "32", large: "40+" },
  { key: "bridesmaidBouquet", small: "12", medium: "15", large: "18" },
  { key: "lowCenterpiece", small: "15", medium: "22", large: "30" },
  { key: "tallCenterpiece", small: "35", medium: "42", large: "50" },
  { key: "archInstall", small: "150", medium: "275", large: "400+" },
  { key: "boutonniere", small: "1", medium: "2", large: "3" },
  { key: "corsage", small: "3", medium: "4", large: "5" },
];

// Which calculator designs to expose as counters, in display order.
export const CALC_DESIGN_ORDER: DesignKey[] = [
  "bridalBouquet",
  "bridesmaidBouquet",
  "boutonniere",
  "corsage",
  "lowCenterpiece",
  "tallCenterpiece",
  "archInstall",
];
